import type React from 'react';
import { useContext, useEffect, useRef } from 'react';
import { CollapseAnimation } from '../../CollapseAnimation';
import { Card } from '../Card';
import { RulesContentContext } from './RulesContentContext';

export interface RulesContentCreationFormProps {
  show: boolean;
  children: React.ReactNode;
}

export const RulesContentCreationForm = ({
  show,
  children,
}: RulesContentCreationFormProps) => {
  const prevShow = useRef<boolean>(show);
  const { showCreationForm } = useContext(RulesContentContext);

  useEffect(() => {
    if (show && show !== prevShow.current) {
      showCreationForm();
    }

    prevShow.current = show;
  }, [show, showCreationForm]);

  return (
    <CollapseAnimation open={show}>
      <div className="pb-2.5">
        <Card>
          <Card.Content>
            <div className="pt-2.5">{children}</div>
          </Card.Content>
        </Card>
      </div>
    </CollapseAnimation>
  );
};
